import { email, required } from '../../utils/validation';

export const ActionValidations = {
  type: [required('models.action.type')],
  email: [required('models.action.emailValue'), email('models.action.email')],
  sms: [required('models.action.smsValue')]
};

class Serializer {
  normalize = data => {
    return {
      id: data.id,
      trigger: {
        id: data.assetInfo.metadata.props.triggerId
      },
      type: data.assetInfo.metadata.props.type,
      value: data.assetInfo.metadata.props.value
    };
  };

  serialize = action => {
    return {
      properties: {
        type: action.type,
        value: action.value,
        triggerId: action.trigger.id
      }
    };
  };
}

export const ActionSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/action/index.js